import { render, staticRenderFns } from "./InstrumentacionDidacticaPage.vue?vue&type=template&id=605ca531&scoped=true&"
import script from "./InstrumentacionDidacticaPage.vue?vue&type=script&lang=js&"
export * from "./InstrumentacionDidacticaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605ca531",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/InstrumentacionDidacticaPage.vue
// module id = 211
// module chunks = 25